import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    padding: '1rem calc(2 * $colWidth)',
    zIndex: 900,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '@mdDown': {
        padding: '1.5rem calc(2 * $colWidth)',
        mixBlendMode: 'difference',
    },
})

export const MenuWrapper = styled('div', {
    display: 'flex',
    gap: '2rem',
})

export const LogoWrapper = styled('div', {
    width: '150px',
    img: {
        width: '100%',
        height: 'auto',
    },

    '@md': {
        width: 'calc(2.5 * $colWidth)',
    },
})

export const MenuItem = styled('a', {
    fontSize: '1.4rem',
    color: '#fff',
})
